(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3935],{

/***/ 69466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RightArrowIcon; },
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




function RightArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#000" : _arrowColor, _bgColor = _param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? "5" : _borderRadius, _removeBorder = _param.removeBorder, removeBorder = _removeBorder === void 0 ? false : _removeBorder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor",
        "bgColor",
        "borderRadius",
        "removeBorder"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                fill: bgColor,
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 24 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "23.25",
                height: "23.25",
                x: "-0.375",
                y: "0.375",
                stroke: arrowColor,
                strokeOpacity: "0.12",
                strokeWidth: !removeBorder ? "0.75" : "0",
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 23.25 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_304_3140)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: arrowColor,
                    strokeWidth: "1.5",
                    d: "M10.39 7.885l3.88 3.88-3.88 3.878"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_304_3140",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H13.714V13.714H0z",
                        transform: "matrix(0 1 1 0 5.14 5.143)"
                    })
                })
            })
        ]
    }));
}
function DownArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#fff" : _arrowColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                        id: "mask0_666_6105",
                        style: {
                            maskType: "alpha"
                        },
                        width: "16",
                        height: "10",
                        x: "0",
                        y: "3",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#D9D9D9",
                            d: "M0 3H16V13H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        mask: "url(#mask0_666_6105)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            stroke: arrowColor,
                            strokeWidth: "1.6",
                            d: "M2.343 5.657L8 11.314l5.657-5.657"
                        })
                    })
                ]
            })
        })
    }));
}


/***/ }),

/***/ 93935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ViewMoreButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(36508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/components/svg.tsx
var svg = __webpack_require__(69466);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/constant.ts
var constant = __webpack_require__(31308);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Svgs.tsx

var instaSvg = function(color) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "Vector",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 1.62651C11.3855 1.62651 11.7108 1.62651 12.6867 1.62651C13.5542 1.62651 13.988 1.84337 14.3133 1.95181C14.747 2.16868 15.0723 2.27711 15.3976 2.60241C15.7229 2.92771 15.9398 3.25301 16.0482 3.68675C16.1566 4.01205 16.2651 4.44578 16.3735 5.31325C16.3735 6.28916 16.3735 6.50602 16.3735 9C16.3735 11.494 16.3735 11.7108 16.3735 12.6867C16.3735 13.5542 16.1566 13.988 16.0482 14.3133C15.8313 14.747 15.7229 15.0723 15.3976 15.3976C15.0723 15.7229 14.747 15.9398 14.3133 16.0482C13.988 16.1566 13.5542 16.2651 12.6867 16.3735C11.7108 16.3735 11.494 16.3735 9 16.3735C6.50602 16.3735 6.28916 16.3735 5.31325 16.3735C4.44578 16.3735 4.01205 16.1566 3.68675 16.0482C3.25301 15.8313 2.92771 15.7229 2.60241 15.3976C2.27711 15.0723 2.06024 14.747 1.95181 14.3133C1.84337 13.988 1.73494 13.5542 1.62651 12.6867C1.62651 11.7108 1.62651 11.494 1.62651 9C1.62651 6.50602 1.62651 6.28916 1.62651 5.31325C1.62651 4.44578 1.84337 4.01205 1.95181 3.68675C2.16868 3.25301 2.27711 2.92771 2.60241 2.60241C2.92771 2.27711 3.25301 2.06024 3.68675 1.95181C4.01205 1.84337 4.44578 1.73494 5.31325 1.62651C6.28916 1.62651 6.61446 1.62651 9 1.62651ZM9 0C6.50602 0 6.28916 0 5.31325 0C4.33735 0 3.68675 0.216868 3.14458 0.433736C2.60241 0.650603 2.06024 0.975904 1.51807 1.51807C0.975904 2.06024 0.759037 2.49398 0.433736 3.14458C0.216868 3.68675 0.108434 4.33735 0 5.31325C0 6.28916 0 6.61446 0 9C0 11.494 0 11.7108 0 12.6867C0 13.6627 0.216868 14.3133 0.433736 14.8554C0.650603 15.3976 0.975904 15.9398 1.51807 16.4819C2.06024 17.0241 2.49398 17.241 3.14458 17.5663C3.68675 17.7831 4.33735 17.8916 5.31325 18C6.28916 18 6.61446 18 9 18C11.3855 18 11.7108 18 12.6867 18C13.6627 18 14.3133 17.7831 14.8554 17.5663C15.3976 17.3494 15.9398 17.0241 16.4819 16.4819C17.0241 15.9398 17.241 15.506 17.5663 14.8554C17.7831 14.3133 17.8916 13.6627 18 12.6867C18 11.7108 18 11.3855 18 9C18 6.61446 18 6.28916 18 5.31325C18 4.33735 17.7831 3.68675 17.5663 3.14458C17.3494 2.60241 17.0241 2.06024 16.4819 1.51807C15.9398 0.975904 15.506 0.759037 14.8554 0.433736C14.3133 0.216868 13.6627 0.108434 12.6867 0C11.7108 0 11.494 0 9 0Z",
                    fill: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 4.33735C6.39759 4.33735 4.33735 6.39759 4.33735 9C4.33735 11.6024 6.39759 13.6627 9 13.6627C11.6024 13.6627 13.6627 11.6024 13.6627 9C13.6627 6.39759 11.6024 4.33735 9 4.33735ZM9 12.0361C7.3735 12.0361 5.96386 10.7349 5.96386 9C5.96386 7.3735 7.26506 5.96386 9 5.96386C10.6265 5.96386 12.0361 7.26506 12.0361 9C12.0361 10.6265 10.6265 12.0361 9 12.0361Z",
                    fill: color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.7711 5.31325C14.3699 5.31325 14.8554 4.82778 14.8554 4.22892C14.8554 3.63005 14.3699 3.14458 13.7711 3.14458C13.1722 3.14458 12.6867 3.63005 12.6867 4.22892C12.6867 4.82778 13.1722 5.31325 13.7711 5.31325Z",
                    fill: color
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useHandleClicks.ts
var useHandleClicks = __webpack_require__(75745);
// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(1657);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(86353);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/ViewMoreButton.tsx






















function ViewMoreButton() {
    var getRedirectionUrl = function getRedirectionUrl() {
        if (forFeaturedProducts) {
            var ref, ref1;
            var isCategory = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.contentItems) === null || ref === void 0 ? void 0 : ref.type) !== constant/* WIDGET_TYPE.FEATURED_COLLECTION */.Lc.FEATURED_COLLECTION;
            if (isCategory) {
                var ref2, ref3;
                return (0,routes.getRoute)("".concat((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : ref2.theme_class) ? routes.PATH.SHOP : routes.PATH.PRODUCT, "?cid=").concat((selectedListParent === null || selectedListParent === void 0 ? void 0 : selectedListParent.id) || 0), store === null || store === void 0 ? void 0 : (ref3 = store.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain);
            }
            return (0,routes.getRoute)(routes.PATH.collectionCategories(selectedListParent === null || selectedListParent === void 0 ? void 0 : (ref1 = selectedListParent.data) === null || ref1 === void 0 ? void 0 : ref1.id), store === null || store === void 0 ? void 0 : store.domain);
        }
        return "";
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var _state = data.state, listPresentationConfig = _state.listPresentationConfig, cardFrameConfig = _state.cardFrameConfig;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var viewAllItemsConfig = getConfigsAndUtils().generalValues.viewAllItemsConfig;
    var setViewAllItemsConfig = getConfigsAndUtils().setters.setViewAllItemsConfig;
    var isVisible = viewAllItemsConfig.showViewAllButton;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), instaUserData = ref6.widgetContextState.instaUserData;
    var onListItemClick = (0,useHandleClicks/* default */.Z)().onListItemClick;
    var router = (0,next_router.useRouter)();
    var store = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var selectedListParent = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.contentItems) === null || ref === void 0 ? void 0 : (ref1 = ref.listItem) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
        return item.isVisible;
    });
    var forFeaturedProducts = (ref4 = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.contentItems) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.type) === null || ref3 === void 0 ? void 0 : ref3.toLocaleLowerCase()) === null || ref4 === void 0 ? void 0 : ref4.includes(constant/* WIDGET_TYPE.FEATURE */.Lc.FEATURE);
    var isBlogPage = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.BLOG */.Lc.BLOG;
    var isInstaPage = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.INSTAGRAM */.Lc.INSTAGRAM;
    var isTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "testimonials";
    var isProductTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS.TESTIMONIALS.type */.Pe.TESTIMONIALS.type;
    var viewMoreLinks = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* WIDGET_TYPE.BLOG */.Lc.BLOG, (0,routes.getRoute)("p/blog", store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain)), (0,_define_property/* default */.Z)(_obj, constant/* WIDGET_TYPE.INSTAGRAM */.Lc.INSTAGRAM, "https://instagram.com/".concat(instaUserData === null || instaUserData === void 0 ? void 0 : (ref1 = instaUserData.user) === null || ref1 === void 0 ? void 0 : ref1.username)), (0,_define_property/* default */.Z)(_obj, constant/* WIDGET_TYPE.TESTIMONIALS */.Lc.TESTIMONIALS, (0,routes.getRoute)("p/testimonial", store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain)), _obj;
    }, [
        instaUserData
    ]);
    if (!isVisible) {
        return null;
    }
    return listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref5 = listPresentationConfig.viewAllItemsButtonConfig) === null || ref5 === void 0 ? void 0 : ref5.map(function(buttonData, btnIndex) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var buttonVariant = (0,utils/* getButtonVariantsData */.Tk)(buttonData);
        var selectedButtonType = buttonVariant[buttonData.type];
        return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
            link: forFeaturedProducts ? getRedirectionUrl() : viewMoreLinks[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                size: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.contentConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.textConfig) === null || ref1 === void 0 ? void 0 : ref1.textSize,
                btnType: buttonData.type,
                buttonData: buttonData,
                selectedButtonData: selectedButtonType,
                variant: selectedButtonType.variant,
                imageDirection: !isBlogPage ? "right" : "left",
                image: !forFeaturedProducts && !isBlogPage && !isInstaPage && !(isTestimonial || isProductTestimonial) && /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownArrowIcon */.G, {
                    arrowColor: buttonData === null || buttonData === void 0 ? void 0 : (ref2 = buttonData.btnStyleConfig) === null || ref2 === void 0 ? void 0 : ref2.textColor,
                    height: "18px",
                    width: "18px",
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-relative", (viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) ? "tw-rotate-180" : "")
                }),
                onClick: function(e) {
                    if (forFeaturedProducts && selectedListParent) {
                        var ref;
                        var forCollection = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.contentItems) === null || ref === void 0 ? void 0 : ref.type) === "featuredCollection";
                        onListItemClick(forCollection ? "collection" : "category", selectedListParent.data, e, false);
                    } else if (isBlogPage || isTestimonial) {
                        router.push(viewMoreLinks[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type]);
                    } else if (isInstaPage) {
                        window.open(viewMoreLinks[constant/* WIDGET_TYPE.INSTAGRAM */.Lc.INSTAGRAM], "_blank");
                    } else setViewAllItemsConfig(function(data) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            areAllItemsVisible: !data.areAllItemsVisible
                        });
                    });
                },
                className: (0,bundle_mjs/* twMerge */.m6)("tw-pointer-events-auto !tw-mt-[52px] !tw-max-w-[100%] !tw-whitespace-nowrap !tw-px-[24px] !tw-py-[12px] !tw-text-[14px] !tw-font-normal !tw-leading-[20px]", !(buttonData === null || buttonData === void 0 ? void 0 : (ref3 = buttonData.buttonAnimationConfig) === null || ref3 === void 0 ? void 0 : ref3.classKey) ? "[&_p]:before:!tw-hidden" : (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref4 = buttonData.buttonAnimationConfig) === null || ref4 === void 0 ? void 0 : ref4.classKey], buttonData.type === buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID ? " !tw-border-none " : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[8px]",
                    children: [
                        isInstaPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-[2px]",
                            children: instaSvg(buttonData === null || buttonData === void 0 ? void 0 : (ref5 = buttonData.btnStyleConfig) === null || ref5 === void 0 ? void 0 : ref5.textColor)
                        }),
                        forFeaturedProducts || isBlogPage || isTestimonial || isInstaPage ? buttonData === null || buttonData === void 0 ? void 0 : buttonData.text : !(viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) ? buttonData === null || buttonData === void 0 ? void 0 : buttonData.text : "See less"
                    ]
                })
            }, btnIndex)
        }) : null;
    });
}


/***/ }),

/***/ 75745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHandleClicks; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10253);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17584);
/* harmony import */ var src_hooks_useItemClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80058);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68037);
/* harmony import */ var src_utils_eventLogger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4134);
/* harmony import */ var src_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86423);
/* harmony import */ var src_utils_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44541);








function useHandleClicks() {
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,src_hooks_useItemClick__WEBPACK_IMPORTED_MODULE_2__/* .useItemClick */ .M)(), 1), onItemClick = ref[0];
    var onListItemClick = function(type, data, e, openInNewTab) {
        e.stopPropagation();
        switch(type){
            case "product":
                {
                    onItemClick(data, e, openInNewTab);
                    break;
                }
            case "collection":
                {
                    (0,src_utils_eventLogger__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(src_constants_common__WEBPACK_IMPORTED_MODULE_1__/* .EVENT_NAMES.COLLECTION_WIDGET_CARD_CLICK */ .Kg.COLLECTION_WIDGET_CARD_CLICK, {
                        collectionId: data.id
                    }, true);
                    var link = (0,src_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)(src_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.collectionCategories(data.id), storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                    !openInNewTab ? next_router__WEBPACK_IMPORTED_MODULE_0___default().push(link) : window.open(link, "_blank");
                    break;
                }
            case "category":
                {
                    var ref, ref1;
                    var redirectUrl = (0,src_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)("".concat((0,src_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_7__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) ? src_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.SHOP : src_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.PRODUCT, "?cid=").concat((data === null || data === void 0 ? void 0 : data.id) || 0), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
                    if (openInNewTab) {
                        window.open(redirectUrl, "_blank");
                    } else {
                        next_router__WEBPACK_IMPORTED_MODULE_0___default().push(redirectUrl, undefined, {
                            shallow: true
                        });
                    }
                    break;
                }
        }
    };
    return {
        onListItemClick: onListItemClick
    };
}


/***/ }),

/***/ 80058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(13051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(36913);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js








function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product, getRoute) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = getRoute((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44541)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 13051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 4134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67936);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);



var eventLogger = function(eventName) {
    var additionalData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, showInConsole = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var userData = (ref = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.data;
    var eventData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        phone: (userData === null || userData === void 0 ? void 0 : userData.phone) || "",
        email: (userData === null || userData === void 0 ? void 0 : userData.email) || ""
    }, additionalData);
    _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_2__/* .pushEventsLog */ .U)({
        event_name: eventName,
        data: eventData
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (eventLogger);


/***/ }),

/***/ 36508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ })

}]);